import { IInference, IAstNode } from './typings';
import { inferenceLogicAndComparison } from './comparison-and-or';
import { inferenceEqualComparison } from './comparison-equal';
import { inferenceSizeComparison } from './comparison-size';
import { inferenceLogicComparison } from './comparison-logic';
import { inferenceNullComparison } from './comparison-null';



// 相等比较符
function isEqualComparisonLikeOperator(operator: string) {
    return [
        'EQUAL', 'NOT-EQUAL',
        'ALL-EQUAL', 'ALL-NOT-EQUAL',
        'ANY-EQUAL', 'ANY-NOT-EQUAL'
    ].includes(operator);
}

// 大小比较符
function isSizeComparisonOperator(operator: string) {
    return [
        'GREAT-THAN-EQUAL', 'GREAT-THAN', 'LESS-THAN-EQUAL', 'LESS-THAN',
        'ALL-GREAT-THAN-EQUAL', 'ALL-GREAT-THAN', 'ALL-LESS-THAN-EQUAL', 'ALL-LESS-THAN',
        'ANY-GREAT-THAN-EQUAL', 'ANY-GREAT-THAN', 'ANY-LESS-THAN-EQUAL', 'ANY-LESS-THAN'
    ].includes(operator);
}

// 判断是否为空值(Null)
function isNullComparisonOperator(operator: string) {
    return [
        'IS', 'IS-NOT',
        'ANY-IS', 'ANY-IS-NOT',
        'ALL-IS', 'ALL-IS-NOT'
    ].includes(operator);
}


export function inferenceComparisonNode(inference: IInference, astNode: IAstNode) {
    const operator = astNode.operator!;
    if (['AND', 'OR'].includes(operator)) {
        return inferenceLogicAndComparison(inference, astNode);
    }

    // 是否相等
    else if (isEqualComparisonLikeOperator(operator)) {
        return inferenceEqualComparison(inference, astNode);
    }

    // 比较大小
    else if (isSizeComparisonOperator(operator)) {
        return inferenceSizeComparison(inference, astNode);
    }

    // 判断空值(Null)
    else if (isNullComparisonOperator(operator)) {
        return inferenceNullComparison(inference, astNode);
    }

    else {
        return inferenceLogicComparison(inference, astNode);
    }
}
